import clsx from "clsx";
import styles from "./index.module.css";

type Props = {};

const Col2 = ({ isActive }: { isActive: boolean }) => {
  return (
    <svg
      className={clsx(styles.icon, isActive ? "" : styles.inactive)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2" width="12" height="5" rx="1" />
      <rect x="2" y="9" width="12" height="5" rx="1" />
    </svg>
  );
};

export default Col2;
